'use client';
const IDENT = 'Stack';
const defaultProps = {
    spacing: '4s',
    align: 'stretch',
    justify: 'flex-start'
};

export { IDENT, defaultProps };
//# sourceMappingURL=Stack.contract.js.map
